import axios from "axios";

let baseURL = process.env.REACT_APP_BASE_URL;
let loginToken = process.env.REACT_APP_LOGIN_TOKEN;

const authEndpoints = [
    `${baseURL}login/signin`,
    `${baseURL}otp/verify`,
    `${baseURL}forgot-password`,
    `${baseURL}regenerate-otp`,
    `${baseURL}sp/ResetPassword`,
    `${baseURL}sp/v2/getRolePages`
];

axios.interceptors.request.use((config) => {
    if (process.env.NODE_ENV !== "development") return config;

    const colony = localStorage.getItem("selectedColony");
    if (!colony || !config.url || !config.url.startsWith(baseURL)) return config;
    if (authEndpoints.includes(config.url)) return config;

    config.url = config.url.replace(baseURL, `https://consolidator.ipxservices.com/proxy/${colony}/api/`);
    return config;
});

export const adminServices = {
    getToken,
    sendPadala,
    serviceCategories,
    registerMerchant,
    registerService,
    login,
    verify,
    sendMerchantPadala,
    updatePDL,
    addClientTransaction,
    updateClientTransaction,
    updatePadala,
    submitConfig,
    addRFQ,
    addRFQDetails,
    addKiosk,
    updateKiosk,
    emailRFQ,
    addPo,
    addReceiving,
    addReceivingItems,
    postData,
    updateData,
    patchData,
    deleteData,
    emailApproval,
    emailReceipt,
    forgoPassword,
    resetPassword,
    getKioskData,
    recipients,
    updateRecipients,
    emailCredentials,
    passwordReset,
    getData,
    updateGlobalMarkup,
    updateFacilityMarkups,
    getInventoryMerchants,
    getMerchantById,
    getMerchantTopSellingProducts,
    getMerchantTransactionHistory,
    getMerchantInventory,
    getRFQByOrderId,
    downloadRFQPdf,
    downloadPOPdf,
    getPoAttachmentByOrderId,
    getAuditLog,
    updateMerchantInventory,
    addMerchantInventoryProducts,
    suggestMerchantProducts,
    unsuggestMerchantProduct,
    getSuggestedProducts,
    updateProduct,
    getBucorApprovalByRequestNo,
    getBucorApprovalHistory,
    updateBucorApprovalStatus,
    updateBucorApprovalItems,
    createIpxOrder,
    searchPdl,
    searchMerchants,
    getOrderList,
    getOrderSummary,
    getOrderDetails,
    getSubProductsByProduct,
    getProductUomConversionsByProduct,
    getProductUomConversion,
    createProductUomConversion,
    createMerchantCutoffs,
    createSupplier,
    getSupplierTypes,
    createSupplierType,
    updateSupplierType,
    deleteSupplierType,
    getProductHistory,
    getNewItemApprovals,
    getMerchantWallet,
    setMerchantStatusV2,
    postMerchantCutoffsInit,
    setMerchantCutoffs,
    updateCutOffStatus,
    getUoms,
    getUnitOfMeasurements,
    createUnitOfMeasurement,
    deleteUnitOfMeasurement,
    createQuotationRequest,
    updateQuotationRequestItems,
    generateRFQPdf,
    approveQuotationRequest,
    createPurchaseOrderDraft,
    createSubProduct,
    updateSubProduct,
    getSupplierById,
    createProduct,
    updateItemApprovalStatus,
    createDeliveryNoteDraft,
    submitDeliveryNote,
    createSalesOrder,
    getSalesOrderDetails,
    updateSalesOrder,
    downloadDeliveryNote,
    finalizePurchaseOrder,
    getPurchaseOrderDetails,
    createDeliveryNote,
    getDeliveryNoteDetails,
    updateDeliveryNote,
    storeProcedure2
}

async function getToken(){
    const config = {
        headers:{
            Authorization : 'Basic anVhbjpwYWJsbw==',
        }
    }

    return await axios.get(baseURL + "token",config);
}

async function serviceCategories(){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.get(`${baseURL}servicecategories`,config);
}

async function getKioskData(id){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.get(`${baseURL}kiosks/${id}`,config);
}

async function sendPadala(token, data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}padala`,data,config);
}

async function postData(endpoint, data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}${endpoint}`,data,config);
}

async function sendMerchantPadala(token, data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}MerchantPadala`,data,config);
}

async function registerMerchant(token, data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}merchants`,data,config);
}

async function registerService(token, data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + token,
        }
    }

    return await axios.post(`${baseURL}services`,data,config);
}

async function login(emailAddr, passwd){
    var token = loginToken;

    const config = {
        headers:{
            'content-type':'application/json',
            'X-Api-Key' : token
        }
    }

    var data = {EmailAddress: emailAddr, Password: passwd}
    
    return await axios.post(`${baseURL}login/signin`,data,config);
}

async function forgoPassword(emailAddr){
    var token = loginToken;

    const config = {
        headers:{
            'content-type':'application/json',
            'X-Api-Key' : token
        }
    }

    var data = {EmailAddress: emailAddr}
    
    return await axios.post(`${baseURL}forgot-password`,data,config);
}

async function verify(pin){
    var token = loginToken;

    const config = {
        headers:{
            'content-type':'application/json',
            'X-Api-Key' : token
        }
    }

    var data = {otpCode: pin, secretKey: localStorage.getItem("secretKey"),email_Address: localStorage.getItem("emailAddr")}
    
    return await axios.post(`${baseURL}otp/verify`,data,config);
}

async function updatePDL(data){
    const config = {
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.put(`${baseURL}clients/` + data.id,data,config);
}

async function passwordReset(data,pin=""){
    const config = {
        headers:{
            'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}users/password-reset?viaOtp=` + pin,data,config);
}

async function updateClientTransaction(data){

    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.put(`${baseURL}clientTransaction/` + data.id,data,config);
}

async function updatePadala(data){

    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.put(`${baseURL}padala/` + data.id,data,config);
}

async function addClientTransaction(data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}clientTransaction`,data,config);
}

async function submitConfig(data){
    const config = {
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}configs`,data,config);
}

async function emailApproval(data){
    const config = {
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}email/send-request`,data,config);
}

async function emailReceipt(data){
    const config = {
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}email/send-receipt`,data,config);
}

async function emailCredentials(data){
    const config = {
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.post(`${baseURL}email/send-credentials`,data,config);
}


async function resetPassword(data){
    var token = loginToken;
    const config = {
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization : 'Bearer ' + token,
        }
    }
    
    return await axios.post(`${baseURL}sp/ResetPassword`,data,config);
}

async function addRFQ(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}rfq`,data,config);
}

async function addRFQDetails(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}rfqdetails`,data,config);
}

async function addKiosk(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}kiosks`,data,config);
}

async function updateKiosk(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.put(`${baseURL}kiosks/` + data.kioskId,data,config);
}

async function emailRFQ(id){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}rfq/send-email/` + id,{},config);
}

async function addPo(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}productorder`,data,config);
}

async function addReceiving(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}receiving`,data,config);
}

async function addReceivingItems(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.post(`${baseURL}receivingdetails`,data,config);
}

async function recipients(){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.get(`${baseURL}emailrecipients`,config);
}

async function updateRecipients(data){
    const config = {
        headers:{
            'Content-Type': 'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    
    return await axios.put(`${baseURL}emailrecipients/1`,data,config);
}

async function updateData(endpoint, data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.put(`${baseURL}${endpoint}`,data,config);
}

async function getData(endpoint){
        const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.get(`${baseURL}${endpoint}`,config);
}

async function patchData(endpoint){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.patch(`${baseURL}${endpoint}`,{},config);
}

async function deleteData(endpoint){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    return await axios.delete(`${baseURL}${endpoint}`,config);
}

async function updateGlobalMarkup(markup){
    return await updateData('MarkupSettings/global', { markup: Number(markup) || 0 });
}

async function updateFacilityMarkups(facilities){
    const payload = {
        facilities: facilities.map(f => ({
            facility: String(f.facility),
            markup: Number(f.markup) || 0
        }))
    };
    return await updateData('MarkupSettings/facilities', payload);
}

async function getInventoryMerchants(keyword = '', page = 1, limit = 10){
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const data = { keyword: String(keyword || '').trim(), page, limit };
    return await axios.post(`${baseURL}sp/v2/inventorymerchant`, data, config);
}

async function getMerchantById(id, params = {}){
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        },
        params
    };
    return await axios.get(`${baseURL}view/merchant/${encodeURIComponent(id)}`, config);
}

async function getMerchantTopSellingProducts(merchantId, page = 1, limit = 10){
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(
        `${baseURL}Merchants/${encodeURIComponent(merchantId)}/top-selling-products?page=${page}&limit=${limit}`,
        config
    );
}

async function getMerchantTransactionHistory(merchantId, page = 1, limit = 10){
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const data = {
        merchantId: Number(merchantId) || merchantId,
        page,
        limit
    };
    return await axios.post(`${baseURL}sp/v2/merchantTransactionHistory`, data, config);
}

async function getMerchantInventory(merchantId, page = 1, limit = 10){
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const normalizedPage = Number(page);
    const data = {
        merchantId: Number(merchantId) || merchantId,
        page: Number.isFinite(normalizedPage) && normalizedPage > 0 ? normalizedPage : 1,
        limit: ""
    };
    return await axios.post(`${baseURL}sp/v2/merchantInventory`, data, config);
}

async function getAuditLog(params = {}) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        },
        params
    };
    return await axios.get(`${baseURL}InventoryMovement/history`, config);
}

async function updateMerchantInventory(id, payload){
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}MerchantInventory/${encodeURIComponent(id)}`, payload, config);
}

async function addMerchantInventoryProducts(merchantId, products){
    const config = {
        headers: {
            'Content-Type': 'application/json-patch+json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const payload = {
        products: Array.isArray(products) ? products : []
    };
    return await axios.post(`${baseURL}MerchantInventory/${encodeURIComponent(merchantId)}`, payload, config);
}

async function suggestMerchantProducts(merchantId, productIds) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const ids = Array.isArray(productIds) ? productIds : [productIds];
    const payload = { merchantId: Number(merchantId) || merchantId, productIds: ids };
    return await axios.post(`${baseURL}MerchantInventory/suggest`, payload, config);
}

async function unsuggestMerchantProduct(merchantId, productId) {
    const config = {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.delete(
        `${baseURL}MerchantInventory/suggest/${encodeURIComponent(productId)}?merchantId=${encodeURIComponent(merchantId)}`,
        config
    );
}

async function getSuggestedProducts(merchantId) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const data = { merchantId: Number(merchantId) || merchantId };
    return await axios.post(`${baseURL}sp/v2/suggestedproducts`, data, config);
}

async function updateProduct(payload) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}products/update-product`, payload, config);
}

async function getBucorApprovalByRequestNo(requestNo) {
    const config = {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(`${baseURL}BucorApprovals/ByRequestNo/${encodeURIComponent(requestNo)}`, config);
}

async function updateBucorApprovalStatus(id, status, remarks) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}BucorApprovals/UpdateStatus/${id}`, { status, remarks }, config);
}

async function getBucorApprovalHistory(id) {
    const config = {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(`${baseURL}BucorApprovals/${encodeURIComponent(id)}/history`, config);
}

async function updateBucorApprovalItems(itemsPayload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}BucorApprovals/items`, itemsPayload, config);
}

async function createIpxOrder(payload) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}IpxOrders`, payload, config);
}

async function searchPdl(keyword) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}sp/v2/searchpdl`, { keyword: String(keyword || '').trim() }, config);
}

async function searchMerchants(keyword) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}sp/v2/searchmerchants`, { keyword: String(keyword || '').trim() }, config);
}

async function getOrderList(params) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}sp/v2/orderList`, params, config);
}

async function getOrderSummary() {
    const config = {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}sp/v2/orderSummary`, {}, config);
}

async function getOrderDetails(orderId) {
    const config = {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(`${baseURL}IpxOrders/${orderId}/details`, config);
}

async function createMerchantCutoffs(merchantId, day, items, status) {
    const config = {
        headers: {
            'Content-Type': 'application/json-patch+json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const normalizedItems = Array.isArray(items)
        ? items
            .filter(i => i && i.name && i.time)
            .map(i => ({
                item_name: String(i.name),
                time: String(i.time),
            }))
        : [];
    const payload = {
        day: String(day || ""),
        items: JSON.stringify(normalizedItems),
        status: String(status || ""),
    };
    return await axios.post(
        `${baseURL}merchant-cutoff/${encodeURIComponent(Number(merchantId) || merchantId)}`,
        payload,
        config
    );
}

async function createSupplier(payload) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}Suppliers`, payload, config);
}

async function getSupplierTypes() {
    return await getData('SupplierTypes');
}

async function createSupplierType(payload) {
    return await postData('SupplierTypes', payload);
}

async function updateSupplierType(id, payload) {
    return await updateData(`SupplierTypes/${encodeURIComponent(id)}`, payload);
}

async function deleteSupplierType(id) {
    return await deleteData(`SupplierTypes/${encodeURIComponent(id)}`);
}

async function getSubProductsByProduct(productId) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(`${baseURL}SubProducts/by-product/${encodeURIComponent(productId)}`, config);
}

async function getProductUomConversionsByProduct(productId) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(`${baseURL}ProductUomConversions/by-product/${encodeURIComponent(productId)}`, config);
}

async function getProductUomConversion(productId, baseUnit, convertedUnit) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(`${baseURL}ProductUomConversions/${encodeURIComponent(productId)}/${encodeURIComponent(baseUnit)}/${encodeURIComponent(convertedUnit)}`, config);
}

async function createProductUomConversion(data) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}ProductUomConversions`, data, config);
}

async function getProductHistory(params = {}) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        },
        params
    };
    return await axios.get(`${baseURL}Products/history`, config);
}

async function getNewItemApprovals() {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.get(`${baseURL}ItemApprovals`, config);
}

async function getMerchantWallet(merchantId) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}sp/v2/get_merchant_wallet`, { merchantId }, config);
}

async function setMerchantStatusV2(statusId, merchantId) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const payload = {
        statusId: Number(statusId),
        merchantId: Number(merchantId),
    };
    return await axios.post(`${baseURL}sp/v2/setMerchantStatus`, payload, config);
}

async function postMerchantCutoffsInit(merchantId) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const payload = {
        merchantId: Number(merchantId) || merchantId,
    };
    return await axios.post(`${baseURL}sp/v2/merchantCutOffs`, payload, config);
}

async function setMerchantCutoffs(cutoffId, day, items, status) {
    const config = {
        headers: {
            'Content-Type': 'application/json-patch+json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const normalizedItems = Array.isArray(items)
        ? items
            .filter(i => i && i.name && i.time)
            .map(i => ({
                item_name: String(i.name),
                time: String(i.time),
            }))
        : [];
    const payload = {
        day: String(day || ""),
        items: JSON.stringify(normalizedItems),
        status: String(status || ""),
    };
    return await axios.put(
        `${baseURL}merchant-cutoff/${encodeURIComponent(Number(cutoffId) || cutoffId)}`,
        payload,
        config
    );
}

async function updateCutOffStatus(cutOffId, newStatus) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    const normalized = String(newStatus || "").toUpperCase();
    if (normalized !== "ACTIVE" && normalized !== "INACTIVE") {
        throw new Error("newStatus must be ACTIVE or INACTIVE");
    }
    const payload = {
        cutOffId: Number(cutOffId) || cutOffId,
        newStatus: normalized,
    };
    return await axios.post(`${baseURL}sp/v2/updateCutOff`, payload, config);
}

async function getUoms() {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}sp/v2/getuoms`, {}, config);
}

async function createQuotationRequest(orderId) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}IpxOrders/${orderId}/create-quotation-request`, {}, config);
}

async function updateQuotationRequestItems(quotationRequestId, payload) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}IpxQuotationRequests/${quotationRequestId}/items`, payload, config);
}

async function generateRFQPdf(quotationRequestId, payload) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}IpxQuotationRequests/${quotationRequestId}/generate-rfq-pdf`, payload, config);
}

async function approveQuotationRequest(payload) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}IpxQuotationRequests/approve`, payload, config);
}

async function createPurchaseOrderDraft(payload) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}IpxPurchaseOrders`, payload, config);
}

async function createSubProduct(subProductData) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}SubProducts`, subProductData, config);
}

async function updateSubProduct(id, subProductData) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}SubProducts/${id}`, subProductData, config);
}

async function getRFQByOrderId(orderId){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    const data = { orderId: Number(orderId) || orderId };
    return await axios.post(`${baseURL}sp/v2/getRFQByOrderId`, data, config);
}

async function downloadRFQPdf(quotationRequestId, file_name, payload = {}) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        },
        responseType: 'blob'
    };

    const response = await axios.post(
        `${baseURL}IpxQuotationRequests/${quotationRequestId}/download-rfq`,
        payload,
        config
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });

    let filename = file_name || `RFQ_${quotationRequestId}.pdf`;
    const disposition = response.headers['content-disposition'];

    if (disposition && disposition.includes('filename=')) {
        filename = disposition.split('filename=')[1].replace(/"/g, '');
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    document.body.appendChild(link);
    link.click();
    link.remove();
}

async function downloadPOPdf(purchaseOrderId, file_name, payload = {}) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        },
        responseType: 'blob'
    };

    const response = await axios.post(
        `${baseURL}IpxPurchaseOrders/${purchaseOrderId}/download-po`,
        payload,
        config
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });

    let filename = file_name || `PO_${purchaseOrderId}.pdf`;
    const disposition = response.headers['content-disposition'];

    if (disposition && disposition.includes('filename=')) {
        filename = disposition.split('filename=')[1].replace(/"/g, '');
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    document.body.appendChild(link);
    link.click();
    link.remove();
}

async function getPoAttachmentByOrderId(orderId){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    const data = { orderId: Number(orderId) || orderId };
    return await axios.post(`${baseURL}sp/v2/getPoAttachment`, data, config);
}

async function getSupplierById(supplierId){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    const data = { supplierId: Number(supplierId) || supplierId };
    return await axios.post(`${baseURL}sp/v2/getSupplierById`, data, config);
}

async function storeProcedure2(endpoint,data){
    const config = {
        headers:{
            'content-type':'application/json',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }
    return await axios.post(`${baseURL}sp/v2/${endpoint}`, data, config);
}

async function createSalesOrder(payload) {
    return await storeProcedure2('spCreateSalesOrder', payload);
}

async function getSalesOrderDetails(salesOrderId) {
    return await storeProcedure2('getSalesOrderDetails', {
        p_sales_order_id: Number(salesOrderId) || salesOrderId
    });
}

async function updateSalesOrder(payload) {
    return await storeProcedure2('spUpdateSalesOrder', payload);
}

async function downloadDeliveryNote(deliveryNoteId) {
    return await storeProcedure2('downloadDeliveryNote', {
        p_delivery_note_id: Number(deliveryNoteId) || deliveryNoteId
    });
}

async function finalizePurchaseOrder(purchaseOrderId, finalizedBy) {
    return await storeProcedure2('finalizePurchaseOrder', {
        p_purchase_order_id: Number(purchaseOrderId) || purchaseOrderId,
        p_finalized_by: finalizedBy ?? null
    });
}

async function getPurchaseOrderDetails(purchaseOrderId) {
    return await storeProcedure2('getPurchaseOrderDetails', {
        p_purchase_order_id: Number(purchaseOrderId) || purchaseOrderId
    });
}

async function createDeliveryNote(payload) {
    return await storeProcedure2('createDeliveryNote', payload);
}

async function getDeliveryNoteDetails(deliveryNoteId) {
    return await storeProcedure2('getDeliveryNoteDetails', {
        p_delivery_note_id: Number(deliveryNoteId) || deliveryNoteId
    });
}

async function updateDeliveryNote(payload) {
    return await storeProcedure2('updateDeliveryNote', payload);
}

async function createDeliveryNoteDraft(payload, file) {
    const token = localStorage.getItem('appToken');
    if (file) {
        const formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        formData.append('attachment', file);
        return await axios.post(`${baseURL}IpxDeliveryNotes/draft`, formData, {
            headers: { Authorization: 'Bearer ' + token }
        });
    }
    return await axios.post(`${baseURL}IpxDeliveryNotes/draft`, payload, {
        headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + token }
    });
}

async function submitDeliveryNote(payload, file) {
    const token = localStorage.getItem('appToken');
    if (file) {
        const formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        formData.append('attachment', file);
        return await axios.post(`${baseURL}IpxDeliveryNotes`, formData, {
            headers: { Authorization: 'Bearer ' + token }
        });
    }
    return await axios.post(`${baseURL}IpxDeliveryNotes`, payload, {
        headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + token }
    });
}

async function createProduct(productData) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.post(`${baseURL}Products`, productData, config);
}

async function updateItemApprovalStatus(id, status, remarks) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
        }
    };
    return await axios.put(`${baseURL}ItemApprovals/${id}/status`, { status, remarks }, config);
}

async function getUnitOfMeasurements() {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
            'accept': 'text/plain'
        }
    };
    return await axios.get(`${baseURL}UnitOfMeasurements`, config);
}

async function createUnitOfMeasurement(data) {
    const config = {
        headers: {
            'content-type': 'application/json-patch+json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
            'accept': 'text/plain'
        }
    };
    return await axios.post(`${baseURL}UnitOfMeasurements`, { name: data.name }, config);
}

async function deleteUnitOfMeasurement(id) {
    const config = {
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('appToken'),
            'accept': 'text/plain'
        }
    };
    return await axios.delete(`${baseURL}UnitOfMeasurements/${id}`, config);
}